import React, { useState, useEffect } from 'react';
import { getDashboardMembre } from '../services/api';
import { FiMapPin, FiMap, FiGrid, FiLayers } from 'react-icons/fi';

const MesParcelles = () => {
  const [parcelles, setParcelles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDashboardMembre().then(r => {
      setParcelles(r.data.parcelles || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div>Chargement...</div>;

  return (
    <div>
      <h1 className="page-title">Mes parcelles</h1>

      {parcelles.length === 0 ? (
        <div className="card">
          <div className="card-body" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
            <FiMapPin style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }} />
            <p style={{ color: '#888', fontSize: '1.1rem' }}>Aucune parcelle attribuée pour le moment.</p>
          </div>
        </div>
      ) : (
        <div className="kpi-grid">
          {parcelles.map((p: any, i: number) => (
            <div className="card" key={p.id || i}>
              <div className="card-header">
                <span><FiMapPin /> Parcelle {p.numero || '-'}</span>
              </div>
              <div className="card-body">
                <div className="info-list">
                  <div className="info-row">
                    <span className="info-label">Projet</span>
                    <span className="info-value">{p.projet_libelle || '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Localisation</span>
                    <span className="info-value">{p.localisation || '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Superficie</span>
                    <span className="info-value">{p.superficie ? p.superficie + ' m²' : '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Lot</span>
                    <span className="info-value">{p.lot || '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">NICAD</span>
                    <span className="info-value">{p.nicad || '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">N° TF</span>
                    <span className="info-value">{p.numtf || '-'}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Position</span>
                    <span className="info-value">{p.position || '-'}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MesParcelles;
